import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { IS_MAGIC_TEAM } from "./lib/brand";

// Margine extra sotto la bottom bar solo su Android (iPhone usa solo safe-area).
if (typeof navigator !== "undefined" && /Android/i.test(navigator.userAgent)) {
  document.documentElement.classList.add("is-android");
}

// Sfondo lilla live: non dipende da env di build di altre PWA.
if (IS_MAGIC_TEAM) {
  document.documentElement.classList.add("tenant-magic-team");
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
